import React from 'react'
import { Input } from '../ui/Input'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select'
import { cn } from '@/lib/utils'

interface PhoneInputSeparatedProps {
  ddi?: string
  ddd?: string
  phone?: string
  onDdiChange: (value: string) => void
  onDddChange: (value: string) => void
  onPhoneChange: (value: string) => void
  disabled?: boolean
  className?: string
}

const DDI_OPTIONS = [
  { value: '+55', label: '+55 🇧🇷' },
  { value: '+1', label: '+1 🇺🇸' },
  { value: '+351', label: '+351 🇵🇹' },
  { value: '+54', label: '+54 🇦🇷' },
  { value: '+58', label: '+58 🇻🇪' },
]

export const PhoneInputSeparated: React.FC<PhoneInputSeparatedProps> = ({
  ddi = '+55',
  ddd = '',
  phone = '',
  onDdiChange,
  onDddChange,
  onPhoneChange,
  disabled = false,
  className = '',
}) => {
  const formatDdd = (value: string): string => {
    const numbers = value.replace(/\D/g, '')
    return numbers.substring(0, 2)
  }

  const formatPhone = (value: string): string => {
    const numbers = value.replace(/\D/g, '')
    const limited = numbers.substring(0, 9)

    // Aplica máscara para telefone (9 ou 8 dígitos)
    if (limited.length <= 4) {
      return limited
    } else if (limited.length <= 9) {
      return `${limited.substring(0, limited.length === 9 ? 5 : 4)}-${limited.substring(limited.length === 9 ? 5 : 4)}`
    }

    return limited
  }

  const handleDddChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formatted = formatDdd(e.target.value)
    onDddChange(formatted)
  }

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formatted = formatPhone(e.target.value)
    onPhoneChange(formatted)
  }

  return (
    <div className={cn('flex gap-2', className)}>
      {/* DDI Select */}
      <Select value={ddi} onValueChange={onDdiChange} disabled={disabled}>
        <SelectTrigger className="w-[90px]">
          <SelectValue placeholder="DDI" />
        </SelectTrigger>
        <SelectContent>
          {DDI_OPTIONS.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {/* DDD Input */}
      <Input
        type="text"
        inputMode="numeric"
        value={ddd}
        onChange={handleDddChange}
        placeholder="DDD"
        disabled={disabled}
        className="w-[70px]"
      />

      {/* Phone Input */}
      <Input
        type="text"
        inputMode="tel"
        value={phone}
        onChange={handlePhoneChange}
        placeholder="00000-0000"
        disabled={disabled}
        className="flex-1"
      />
    </div>
  )
}
